import React, { useState } from 'react';
import Tabs from '../../../../components/tabs';

const DetailsTabs = ({tabs}) => {
  const [activeTab, setActiveTab] = useState(tabs ? tabs[0].id : null);



  const handleTabClick = (tabId) => {
    if (tabId !== 'disabled') {
      setActiveTab(tabId);
    }
  };

  return (
    <div className='w-full md:px-20 md:py-10'>
      <Tabs tabs={tabs} activeTab={activeTab} onTabClick={handleTabClick} />
      {/* Other components */}
    </div>
  );
};

export default DetailsTabs;
